import { observer } from 'mobx-react-lite';
import { SearchScenarioId, SearchScopePicker } from 'owa-search';
import getFolderMenuOptions from '../utils/getFolderMenuOptions';
import getSelectedSearchScopeDisplayName from '../utils/getSelectedSearchScopeDisplayName';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { MailSearchBoxContainerHandle } from './MailSearchBoxContainer';
import * as React from 'react';

export interface FolderScopePickerProps {
    searchBoxRef: React.RefObject<MailSearchBoxContainerHandle>;
}

export default observer(function FolderScopePicker(props: FolderScopePickerProps) {
    const onSearchScopeSelected = React.useCallback((ev?: React.MouseEvent<unknown>) => {
        props.searchBoxRef.current.onSearchScopeSelected(SearchScenarioId.Mail);
    }, []);

    const searchScopes = () => {
        const menuItems: IContextualMenuItem[] = [];
        return getFolderMenuOptions(menuItems);
    };

    const selectedSearchScope = () => {
        return getSelectedSearchScopeDisplayName();
    };

    return (
        <SearchScopePicker
            onSearchScopeSelected={onSearchScopeSelected}
            selectedSearchScope={selectedSearchScope}
            scenarioId={SearchScenarioId.Mail}
            searchScopes={searchScopes}
        />
    );
});
